export default __webpack_public_path__ + "66cde58.png";